import React, { FC } from 'react';
import { Pencil, Info, Search, Check } from 'lucide-react';
import { CellState, ReviewCell, ReviewContent, EditIconButton, StatusIconContainer } from '../NewVerificationTab.styles';
import { ExpandableTableRow, DataPointType } from '../NewVerificationTab.data';
import { resolveReviewCellText } from '../NewVerificationTab.utils';

interface ReviewCellContentProps {
  row: ExpandableTableRow;
  colKey: string;
  state: CellState;
  rowIndex: number;
  canEdit: boolean;
  onEditClick: (
    colKey: 'manualProcess' | 'finalReview',
    rowIndex: number,
    currentValue: React.ReactNode,
    dataPointType: DataPointType,
  ) => void;
}

const ReviewIcon: FC<{ state: CellState }> = ({ state }) => {
  switch (state.reviewIcon) {
    case 'search':
      return (
        <StatusIconContainer>
          <Search className='w-4 h-4 text-[#f5a623]' />
        </StatusIconContainer>
      );
    case 'info':
      return (
        <StatusIconContainer>
          <Info className='w-4 h-4 text-[#ff8800]' />
        </StatusIconContainer>
      );
    case 'check':
      return (
        <StatusIconContainer>
          <Check className='w-4 h-4 text-green-600' />
        </StatusIconContainer>
      );
    case 'question':
      return (
        <StatusIconContainer>
          <span className='text-[#1c2024] text-sm font-bold leading-4'>?</span>
        </StatusIconContainer>
      );
    default:
      return null;
  }
};

export const ReviewCellContent: FC<ReviewCellContentProps> = ({ row, colKey, state, rowIndex, canEdit, onEditClick }) => (
  <ReviewCell>
    <ReviewIcon state={state} />
    <ReviewContent>{resolveReviewCellText(row, colKey, state)}</ReviewContent>
    {canEdit && (
      <EditIconButton
        onClick={(): void =>
          onEditClick(
            colKey as 'manualProcess' | 'finalReview',
            rowIndex,
            row[colKey as keyof ExpandableTableRow] as React.ReactNode,
            row.dataPointType,
          )
        }
      >
        <Pencil className='w-4 h-4 text-gray-600' />
      </EditIconButton>
    )}
  </ReviewCell>
);
